import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import DateTime from "../../../../_common/DateTime"
import NRTButton from "../../../../_common/_buttons/Button"
import Download from "../../../../_common/_icons/Download"
import Linkify from "react-linkify"

const ForumMessage = ({ author, date, text, sentByUser, file,
                      }) => {

    const style = sentByUser ? {
        background: '#b3f9dc',
        alignSelf: 'flex-end',
        borderBottomLeftRadius: '1rem',
        borderBottomRightRadius: 0,

    } : {}

    const buttonFileStyle = sentByUser ? {background: '#52D59D'} : {background: '#cecece'}

    return (
        <div style={style} className='nrt-ead-forum-message'>
            <h4>{author}:</h4>
            <DateTime format={'DD/MM - HH:mm'} date={date}/>
            <p>
                {
                    file &&
                    <NRTButton style={buttonFileStyle} onClick={() => window.open(file,'_blank')}
                               content={<Download/>}
                    />
                }
                <span className={file ? 'fileName' : ''}>
                    <Linkify properties={{target: '_blank'}}>{text}</Linkify>
                </span>
            </p>
        </div>
    )
}

ForumMessage.propTypes = {
    sentByUser: PropTypes.bool,
    author: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    history: PropTypes.object,
}

ForumMessage.defaultProps = {
    sentByUser: false
}

export default ForumMessage



// WEBPACK FOOTER //
// ./src/components/_ead/ForumMessages/_components/Message/index.js